<template>
  <v-form :ref="`form-${detailProp.todolist_id}-ref`" @keydown.enter="submit">
    <div
      class="todo-list-table--body"
      :style="{
        background: backgroundRow,
      }"
    >
      <section
        title="ลำดับ"
        style="flex-basis: 100px"
        class="d-flex align-center justify-center"
      >
        {{ index }}
      </section>
      <section
        title="ชื่อร้านค้าช่วง"
        style="flex-basis: 150px"
        class="d-flex align-center"
      >
        <div v-if="detail.isEdit" class="px-2">
          <v-autocomplete
            v-model="detail.customer_id"
            class="v-todo-list-input"
            :items="listCustomer"
            item-value="customer_id"
            item-text="customer_name"
            :rules="[(v) => !!v || 'เลือกชื่อร้านค้าช่วง']"
            color="#aa0c1e"
            append-icon="mdi-chevron-down"
            dense
            hide-details
            outlined
            @change="changeCustomer"
          ></v-autocomplete>
        </div>
        <div v-else class="px-2">
          <span class="line-clamp-1">
            {{ detailProp.customer_name || '-' }}
          </span>
          <span>{{ detailProp.ScgBPNumber || '-' }}</span>
        </div>
      </section>
      <section
        title="จังหวัด/อำเภอ"
        style="flex-basis: 150px"
        class="d-flex align-center"
      >
        <div v-if="detail.isEdit" class="px-2">
          <div v-if="detail.customer_id">
            <span>{{ detail.PROVINCE_NAME || '-' }} /</span>
            <br />
            <span>{{ detail.AMPHUR_NAME || '-' }}</span>
          </div>
          <div v-else>
            <span>-</span>
          </div>
        </div>
        <div v-if="!detail.isEdit" class="px-2">
          <span>{{ detailProp.PROVINCE_NAME || '-' }} /</span>
          <br />
          <span>{{ detailProp.AMPHUR_NAME || '-' }}</span>
        </div>
      </section>
      <section
        title="ประเภทงาน"
        style="flex-basis: 150px"
        class="d-flex align-center justify-center"
      >
        <div v-if="detail.isEdit" class="px-2">
          <v-autocomplete
            v-model="detail.task_type"
            class="v-todo-list-input"
            :items="taskTypeList"
            item-text="name"
            item-value="id"
            :rules="[(v) => !!v || 'เลือกประเภทงาน']"
            color="#aa0c1e"
            append-icon="mdi-chevron-down"
            dense
            hide-details
            outlined
          ></v-autocomplete>
        </div>
        <div v-else class="text-center">
          <span>{{ detailProp.task_type_name || '-' }}</span>
          <div v-if="detailProp.winloss === '1'" class="task-type--win">
            Win
          </div>
          <div v-if="detailProp.winloss === '2'" class="task-type--loss">
            Loss
          </div>
        </div>
      </section>
      <section
        title="ชื่องาน"
        style="flex-basis: 150px"
        class="d-flex align-center justify-center"
      >
        <div v-if="detail.isEdit" class="px-2">
          <v-text-field
            v-model="detail.detail"
            class="v-todo-list-input"
            :rules="[(v) => !!v || 'ระบุชื่องาน']"
            color="#aa0c1e"
            dense
            hide-details
            @keypress.enter.prevent="() => {}"
          ></v-text-field>
        </div>
        <div v-else class="pa-2">
          <span>
            {{ detailProp.detail || '-' }}
          </span>
        </div>
      </section>
      <section
        title="กำหนดเสร็จ"
        style="flex-basis: 180px"
        class="d-flex align-center justify-center"
      >
        <div v-if="detail.isEdit" class="px-2">
          <v-menu
            ref="dateMenu"
            v-model="dateMenu"
            :close-on-content-click="false"
            left
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="dateFormat(detail.due_date)"
                class="v-todo-list-input"
                placeholder="กำหนดเสร็จ"
                append-icon="rd-calendar-days"
                color="#a9182a"
                outlined
                dense
                hide-details
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="detail.due_date"
              color="#aa0c1e"
              no-title
              :allowed-dates="disablePastDates"
              @input="dateMenu = false"
            ></v-date-picker>
          </v-menu>
        </div>
        <div v-else>
          <span>{{ dateFormat(detailProp.due_date) || '-' }}</span>
        </div>
      </section>
      <section
        title="Preview"
        style="flex-basis: 150px"
        class="d-flex align-center justify-center"
      >
        <div v-if="detail.isEdit" class="d-flex gap-12">
          <button class="btn-action--undo" @click.prevent="undoTodo()">
            <v-icon color="#fff">mdi-arrow-u-left-top</v-icon>
          </button>

          <button
            v-if="detail.isNew"
            class="btn-action--save"
            @click.prevent="addTodo()"
          >
            <v-icon color="#fff">mdi-content-save-outline</v-icon>
          </button>

          <TodoEditDialog
            v-if="!detail.isNew"
            title="ยืนยันที่จะแก้ไขข้อมูลนี้หรือไม่ ?"
            label="เหตุผลการแก้ไข"
            @confirm="(note) => updateTodo(note)"
          >
            <template #activate="{ openDialog }">
              <button class="btn-action--save" @click.prevent="openDialog()">
                <v-icon color="#fff">mdi-content-save-outline</v-icon>
              </button>
            </template>
          </TodoEditDialog>
        </div>
        <div v-else class="d-flex gap-12">
          <TodoEditDialog
            title="ยืนยันที่จะลบข้อมูลนี้หรือไม่ ?"
            :sub-title="`BPNO : ${detailProp.customer_id} | ${detailProp.customer_name}`"
            label="เหตุผลการลบ"
            @confirm="(note) => removeTodo(note)"
          >
            <template #activate="{ openDialog }">
              <button class="btn-action--delete" @click.prevent="openDialog()">
                <v-icon color="#a9182a">mdi-trash-can-outline</v-icon>
              </button>
            </template>
          </TodoEditDialog>
          <button
            class="btn-action--edit"
            @click.prevent="openEdit()"
            :disabled="detailProp.is_flag === '1'"
          >
            <v-icon color="#4A90E2">mdi-pencil-outline</v-icon>
          </button>
        </div>
      </section>
    </div>
  </v-form>
</template>

<script>
import dayjs from 'dayjs'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import TodoEditDialog from '@/components/v2/todoList/dialog/TodoEditDialog.vue'

dayjs.extend(isSameOrBefore)

export default {
  components: {
    TodoEditDialog,
  },
  props: {
    index: {
      type: [Number, String],
      default: '-',
    },
    detailProp: {
      type: Object,
      default: () => {},
    },
    listCustomer: {
      type: Array,
      default: () => [],
    },
    taskTypeList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      detail: {},
      dateMenu: false,
    }
  },
  computed: {
    backgroundRow() {
      if (this.detailProp.isNew) {
        return '#fff'
      }
      if (this.index % 2 === 0) {
        return '#F8F8F8'
      }
      return '#fff'
    },
  },
  mounted() {
    this.detail = structuredClone(this.detailProp)
  },
  methods: {
    openEdit() {
      this.detail = structuredClone(this.detailProp)
      this.detail.isEdit = true
    },
    disablePastDates(date) {
      return dayjs().isSameOrBefore(date, 'day')
    },
    changeCustomer() {
      const customer = this.listCustomer.find(
        (item) => item.customer_id === this.detail.customer_id,
      )
      if (customer) {
        this.detail.PROVINCE_NAME = customer.provinces
        this.detail.AMPHUR_NAME = customer.amphur
      }
    },
    dateFormat(date) {
      if (date) {
        return dayjs(date).format('DD/MM/YYYY')
      }
      return ''
    },
    undoTodo() {
      if (this.detailProp.isNew) {
        // remove new todo
        this.$emit('removeNewTodo', this.detailProp.todolist_id)
      } else {
        // undo edit
        this.detail = structuredClone(this.detailProp)
      }
    },
    async addTodo() {
      // validate form
      if (this.$refs[`form-${this.detailProp.todolist_id}-ref`].validate()) {
        // add new todo
        try {
          const res = await this.$axios.post(
            `${this.$baseAPIControl}/todolist/reciveTask_OSR`,
            {
              user_id: this.$store.state.auth.user.id,
              customer_id: this.detail.customer_id,
              task_type: this.detail.task_type,
              detail: this.detail.detail,
              due_date: this.detail.due_date,
            },
            { headers: this.setheaders },
          )

          if (res.status === 200) {
            Swal.fire({
              icon: 'success',
              title: 'สร้างงานมอบหมายสำเร็จ',
              showConfirmButton: false,
              timer: 1500,
            })

            this.$emit('saveNewTodo', this.detailProp)
          }
        } catch (error) {
          console.error(error)
        }
      }
    },
    async updateTodo(note) {
      // validate form
      if (this.$refs[`form-${this.detailProp.todolist_id}-ref`].validate()) {
        // update todo
        try {
          const { data } = await this.$axios.post(
            `${this.$baseAPIControl}/todolist/updateTask`,
            {
              todolist_id: this.detailProp.todolist_id,
              shop_id: this.detailProp.shop_id,
              user_id: this.detailProp.osr_id,
              customer_id: this.detail.customer_id,
              task_type: this.detail.task_type,
              detail: this.detail.detail,
              remark: note,
              due_date: this.detail.due_date,
            },
            { headers: this.setheaders },
          )

          if (data.items === 'success') {
            Swal.fire({
              icon: 'success',
              title: 'แก้ไขข้อมูลสำเร็จ',
              showConfirmButton: false,
              timer: 1500,
            }).then(() => {
              this.detail.isEdit = false
              this.$emit('updateTodo')
            })
          } else {
            throw new Error('error')
          }
        } catch (error) {
          console.error(error)
          Swal.fire({
            icon: 'error',
            title: 'แก้ไขข้อมูลไม่สำเร็จ',
            confirmButtonText: 'ตกลง',
          })
        }
      }
    },
    async removeTodo(note) {
      try {
        const { data } = await this.$axios.post(
          `${this.$baseAPIControl}/todolist/deleteTask`,
          {
            todolist_id: this.detailProp.todolist_id,
            flag: '2',
            remark: note,
          },
          { headers: this.setheaders },
        )

        if (data.items === 'success') {
          Swal.fire({
            icon: 'success',
            title: 'ลบข้อมูลสำเร็จ',
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            this.$emit('removeTodo')
          })
        } else {
          throw new Error('error')
        }
      } catch (error) {
        console.error(error)
        Swal.fire({
          icon: 'error',
          title: 'ลบข้อมูลไม่สำเร็จ',
          confirmButtonText: 'ตกลง',
        })
      }
    },
  },
}
</script>

<style lang="scss">
.v-todo-list-input {
  font-size: 14px !important;
}
</style>

<style lang="scss" scoped>
.todo-list-table--body {
  display: flex;
  width: 1030px;
  font-size: 14px;

  & section {
    min-height: 70px;
    flex-shrink: 0;
  }
}

.btn-action {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background: #fff;
  &:disabled {
    i {
      color: #aeaeae !important;
    }
    background: #e5e5e5;
    border-color: #e5e5e5;
  }
  &--delete {
    @extend .btn-action;
    border: 1px solid #ff5252;
  }
  &--edit {
    @extend .btn-action;
    border: 1px solid #4a90e2;
  }
  &--undo {
    @extend .btn-action;
    border: 1px solid #a9182a;
    background: #a9182a;
  }
  &--save {
    @extend .btn-action;
    border: 1px solid #0a4eff;
    background: #0a4eff;
  }
}

.task-type {
  border-radius: 4px;
  padding: 2px 12px;
  font-size: 14px;
  font-weight: 500;
  &--win {
    @extend .task-type;
    background: #edf8ec;
    color: #259b12;
  }
  &--loss {
    @extend .task-type;
    background: #feeced;
    color: #ff5252;
  }
}
</style>
